import { Button as ButtonPR } from "primereact/button";

import css from "./custom-button.module.css";

export const CustomButton = (props) => {
  
  let setProps = props;

  if (props.props) {
    setProps = props.props;
  }

  const cssBtn = [css.button, css[setProps.color]].join(' ');

  return (
    <ButtonPR
      {...setProps}
      className={cssBtn}
    />
	);
};
